import styled, { keyframes } from "styled-components"
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import { TbLoader2 } from "react-icons/tb";
import { FaRegTrashCan } from "react-icons/fa6";
import { useContext, useEffect, useState } from "react"
import { useModal } from "../../../contexts/ModalContext";
import ModalDeleteMeta from "./ModalDeleteMeta";
import { VerifyPermission } from "../../../Funcoes/VerifyPermission";
import { AuthContext } from "../../../Auth/AuthProvider";
import { formatarData } from "../../../Funcoes/FormatarData";

import useApi from "../../../hooks/useApi";
const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    box-sizing: border-box;
    border: 1px solid #ccc;
`
const TituloCelula = styled.th`
    text-align: left;
    border-bottom: 1px solid #CCC;
    padding: 10px 0 10px 10px;
    & h3 {
        margin: 0;
        font-size: 15px;
        color: #000;
    }
    width: ${props => props.width + 'px' || 'auto'};
`
const LinhaCorpoLoad = styled.tr`
    background-color: #fff;
`
const CelulaValor = styled.td`
    box-sizing: border-box;
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #CCC;
    font-size: 12px;
    color: #555;
    width: ${props => props.width + 'px' || 'auto'};
`
const ContainerLoad = styled.div`
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const ContainerLoadContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    & p{
        font-size: 13px;
        text-align: center;
        margin: 0;
    }
    color: #000;
`
const ContainerLoadIcon = styled.div`
    color: #000;
    width: 40px;
    height: 40px;
`
const IconLoading = styled(TbLoader2)`
    width: 100%;
    height: 100%;
    animation: ${spin} 1s linear infinite;
`
const LinhaCorpo = styled.tr`
    &:nth-child(even) {
        background-color: #f9f9f9;
    }
    &:hover {
        background-color: #d8f2ee;
    }
`
const ContainerValorProgresso = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`
const ContainerProgresso = styled.div`
    width: 70px;
    height: 5px;
    background-color: #e0e0e0;
    border-radius: 10px;
    overflow: hidden;
`
const BarraProgresso = styled.div`
    height: 100%;
    background-color:
        ${props => props.percent >= 100 ? '#4caf50' : props.percent >= 50 ? '#ffeb3b' : '#f44336'}
    ;
    width: ${props => props.percent}%;
    border-radius: 10px 0 0 10px;
`
const ContainerIconTrash = styled.div`
    width: 20px;
    height: 20px;
`
const IconTrash = styled(FaRegTrashCan)`
    width: 100%;
    height: 100%;
    color: #ff0000;
    transition: .3s;
    &:hover{
        color: #d40000;
        scale: 1.07;
    }
    cursor: pointer;
`

const ContainerComments = styled.div`
    width: 100%;
    margin-top: 25px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 6px;
    box-sizing: border-box;
`;

const TituloComments = styled.h3`
    margin: 0 0 15px 0;
    font-size: 15px;
    color: #000;
`;

const ComentarioItem = styled.div`
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;
    color: #000;
    text-align: justify;
`;

const ComentarioHeader = styled.div`
    font-size: 12px;
    color: #1c1c1e;
    font-weight: bold;
    margin-bottom: 2px;
`;

const ComentarioEmail = styled.div`
    font-size: 11px;
    color: #666;
    margin-bottom: 6px;
`;

const ComentarioData = styled.div`
    margin-top: 8px;
    font-size: 11px;
    color: #777;
    text-align: right;
`;

const TextAreaComentario = styled.textarea`
    width: 100%;
    height: 80px;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 10px;
    font-size: 13px;
    resize: none;
    margin-top: 10px;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #263a4a;
    }
`;

const ButtonSalvarComentario = styled.button`
    margin-top: 10px;
    padding: 10px 15px;
    background-color: #263a4a;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;

    &:hover {
        background-color: #1b2c38;
    }

    &:disabled {
        background-color: #8a9bab;
        cursor: not-allowed;
    }
`;

const comentarios = [
    {
        "id": 1,
        "usuario_id": 23,
        "nome": "Matheus Oliveira",
        "email": "matheus.oliveira@empresa.com",
        "comentario": "Verifiquei a configuração e ajustei o período para 12 meses.",
        "data_hora": "2025-12-04 10:32:19"
    },
    {
        "id": 2,
        "usuario_id": 11,
        "nome": "Ana Pereira",
        "email": "ana.pereira@empresa.com",
        "comentario": "Existe um erro no cálculo da carga horária mínima.",
        "data_hora": "2025-12-04 10:45:02"
    },
    {
        "id": 3,
        "usuario_id": 23,
        "nome": "Matheus Oliveira",
        "email": "matheus.oliveira@empresa.com",
        "comentario": "Corrigido! Teste novamente quando possível.",
        "data_hora": "2025-12-04 10:50:44"
    }
]

const UserMetas = ({ fecharModal, UpdateUsers, usuario, data_inicio, data_final }) => {
    const api = useApi();


    const { openModal, isModalOpen, closeModal } = useModal()
    const { user } = useContext(AuthContext);

    const calcularProgresso = (concluido, meta) => {
        if (meta === 0) return 0;
        const percent = (concluido / meta) * 100;
        return percent;
    }

    const [loading, setLoading] = useState(true);
    const [dados, setDados] = useState([]);

    const fetchDados = async () => {

        setLoading(true);

        try {
            const { data } = await api.post('/Painel/API/Checklist/GetColabMetas/', {
                data_inicial: data_inicio,
                data_final: data_final,
                id: usuario.usuario_id
            });
            setDados(data);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false)
        }

    }

    const [deleteItem, setDeleteItem] = useState(null);

    const openDeleteModal = (item) => {

        openModal('modalDelete');
        setDeleteItem(item);

    }

    const closeDeleteModal = () => {

        closeModal();
        setDeleteItem(null);

    }

    const [comentarios, setComentarios] = useState([]);
    const [novoComentario, setNovoComentario] = useState("");
    const [loadingComentarios, setLoadingComentarios] = useState(false);

    const [ savingComent, setSavingComent ] = useState( false );

    const fetchComentarios = async () => {
        setLoadingComentarios(true);

        try {
            const { data } = await api.post('/Painel/API/Checklist/GetComentariosSemana/', {
                data_inicial: data_inicio,
                usuario_id: usuario.usuario_id
            })

            console.log(data);
            setComentarios(data);

        } catch (e) {
            console.log(e);
        } finally {
            setLoadingComentarios(false);
        }

    }

    useEffect(() => {

        fetchDados();
        fetchComentarios();

    }, [usuario])

    const salvarComentario = async () => {

        if (!novoComentario.trim()) return;

        setSavingComent( true );

        try {
            const { data } = await api.post('/Painel/API/Checklist/SalvarComentario/', {
                comentario: novoComentario,
                usuario_id: usuario.usuario_id,
                data: data_inicio
            }, { withCredentials: true })

            console.log(data);

            setNovoComentario("");
            fetchComentarios();
        } catch (e) {
            console.log(e);
        }finally{
            setSavingComent(false);
        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="lg" header close={fecharModal} >
                    <Tabela>
                        <thead>
                            <tr>
                                <TituloCelula colSpan={4} >
                                    <h3>METAS DO COLABORADOR - {usuario.nome}</h3>
                                </TituloCelula>
                            </tr>
                            <tr>
                                <TituloCelula>
                                    <h3>TIPO</h3>
                                </TituloCelula>
                                <TituloCelula width={130} >
                                    <h3>META SEMANAL</h3>
                                </TituloCelula>
                                <TituloCelula width={130} >
                                    <h3>CONCLUSÃO</h3>
                                </TituloCelula>
                                <TituloCelula></TituloCelula>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading ? (
                                    <LinhaCorpoLoad>
                                        <CelulaValor colSpan={4} >
                                            <ContainerLoad>
                                                <ContainerLoadContent>
                                                    <ContainerLoadIcon>
                                                        <IconLoading />
                                                    </ContainerLoadIcon>
                                                    <p>CARREGANDO...</p>
                                                </ContainerLoadContent>
                                            </ContainerLoad>
                                        </CelulaValor>
                                    </LinhaCorpoLoad>
                                ) : (
                                    <>
                                        {
                                            dados.map((obj) => {
                                                const progresso = calcularProgresso(obj.realizados, obj.meta_semanal)

                                                return (
                                                    < LinhaCorpo key={obj.id} >
                                                        <CelulaValor>
                                                            {obj.nome}
                                                        </CelulaValor>
                                                        <CelulaValor>
                                                            {obj.realizados}/{obj.meta_semanal}
                                                        </CelulaValor>
                                                        <CelulaValor width={160} >
                                                            <ContainerValorProgresso>
                                                                <ContainerProgresso>
                                                                    <BarraProgresso percent={progresso} />
                                                                </ContainerProgresso>
                                                                {progresso.toFixed(2)}%
                                                            </ContainerValorProgresso>
                                                        </CelulaValor>
                                                        {
                                                            VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'delete-meta' }) && (
                                                                <CelulaValor width={60} >
                                                                    <ContainerIconTrash>
                                                                        <IconTrash onClick={() => openDeleteModal(obj)} />
                                                                    </ContainerIconTrash>
                                                                </CelulaValor>
                                                            )
                                                        }
                                                    </LinhaCorpo>
                                                )
                                            })
                                        }
                                    </>
                                )
                            }
                        </tbody>
                    </Tabela>
                    <ContainerComments>
                        <TituloComments>COMENTÁRIOS DA SEMANA</TituloComments>
                        {loadingComentarios ?
                            <>
                                <p style={{ fontSize: "13px", color: "#333" }}>Carregando comentários...</p>
                            </>
                            : comentarios.length > 0 ?
                                <>
                                    {
                                        comentarios.map((c) => (
                                            <ComentarioItem key={c.id}>
                                                <ComentarioHeader>{c.usuario}</ComentarioHeader>
                                                <ComentarioEmail>{c.email}</ComentarioEmail>
                                                {c.comentario}
                                                <ComentarioData>{formatarData(c.data_preenchido, true)}</ComentarioData>
                                            </ComentarioItem>
                                        ))
                                    }
                                </>
                                :
                                <>
                                    <p style={{ fontSize: "13px", color: "#333" }}>
                                        Nenhum comentário registrado para esta semana.
                                    </p>
                                </>
                        }
                        {
                            VerifyPermission(user, { modulo: 'ssma', submodulo: 'check-list', funcao: 'add-comentarios' })
                        }
                        <TextAreaComentario
                            placeholder="Adicionar novo comentário..."
                            value={novoComentario}
                            onChange={(e) => setNovoComentario(e.target.value)}
                            disabled={ savingComent }
                        />

                        <ButtonSalvarComentario
                            disabled={(!novoComentario.trim() || savingComent)}
                            onClick={salvarComentario}
                        >
                            { savingComent ? "SALVANDO..." : "SALVAR COMENTÁRIO"}
                        </ButtonSalvarComentario>
                    </ContainerComments>
                </Modal>
                {
                    isModalOpen('modalDelete') && (
                        <ModalDeleteMeta
                            item={deleteItem}
                            fecharModal={closeDeleteModal}
                            atualizarUsers={UpdateUsers}
                            atualizarMetas={fetchDados}
                        />
                    )
                }
            </Overlay >
        </>
    )
}

export default UserMetas;